/* eslint-disable arrow-body-style */
/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
import { useState, useEffect } from "react";
import { Box, Button, Typography, Modal, TextField, Fade, List, ListItem } from "@mui/material";
import { styled } from "@mui/material/styles";

const BoxWrapperstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 35px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .topContent": {
    marginBottom: "30px",
    "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
    "& p": { fontSize: "16px", marginBottom: "8px", color: theme.palette.text.primary },
  },
  "& .InputWrapper": {
    marginBottom: "22px",
    "& .MuiFormControl-root": {
      "& .MuiInputBase-root": {
        padding: "0",
      },
    },
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      "&:focus": {
        outline: "none",
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

export default function AiGeneratePopup({ handleHeadingUpdate, type, headingText, setHeadingText, titleText, setTitleText, open, setOpen }) {
  const [editedTitle, setEditedTitle] = useState(titleText);

  useEffect(() => {
    setEditedTitle(titleText);
  }, [titleText]);

  const handleClose = () => setOpen(false);

  const handleSave = () => {
    if (handleHeadingUpdate) {
      handleHeadingUpdate(editedTitle);
    }
    handleClose();
    if (editedTitle && editedTitle.trim()) {
      setTitleText(editedTitle);
    }
  };

  const handleEditHeading = (index, newValue) => {
    setHeadingText(prevState => {
      const updatedHeadings = prevState.heading.map((heading, i) => {
        return i === index ? newValue : heading; // Update the specific heading at the given index
      });

      return {
        ...prevState, // Preserve the other properties like `index`
        heading: updatedHeadings, // Update the `heading` array with the new value
      };
    });
  };

  return (
    <Modal open={open}>
      <Fade in={open}>
        <BoxWrapperstyle>
          <Box className="topContent">
            <Typography component="h4">Edit {type}</Typography>
          </Box>
          <Box className="InputWrapper">
            {headingText?.heading && (
              <List>
                {headingText?.heading.map((value, i) => (
                  <ListItem key={i}>
                    <TextField value={value} onChange={e => handleEditHeading(i, e.target.value)} fullWidth variant="outlined" />
                  </ListItem>
                ))}
              </List>
            )}
            {editedTitle && <TextField className="textFieldText" multiline value={editedTitle} onChange={e => setEditedTitle(e.target.value)} fullWidth variant="outlined" />}
          </Box>
          <Box className="BtnWrapper">
            <Button onClick={handleSave}>Save</Button>
            <Button className="OutlineBtn" onClick={handleClose}>
              Cancel
            </Button>
          </Box>
        </BoxWrapperstyle>
      </Fade>
    </Modal>
  );
}
